import { __read } from "tslib";
import React, { useState } from 'react';
import { SectionHeader } from '@marvelapp/ui-internal';
import { Box, FlexWrap } from '@marvelapp/ui';
import { space } from '@marvelapp/theme';
export default function NavigationGridWrap(_a) {
    var children = _a.children, screenCount = _a.screenCount, groupName = _a.groupName;
    var _b = __read(useState(false), 2), isCollapsed = _b[0], setIsCollapsed = _b[1];
    var handleCollapseGroup = function () {
        setIsCollapsed(!isCollapsed);
    };
    var GUTTER = 30;
    return (React.createElement("div", null,
        groupName && (React.createElement(SectionHeader, { gutter: GUTTER, headerHeight: 100, isCollapsed: isCollapsed, onToggleCollapsed: handleCollapseGroup, sectionName: groupName, showEmptyState: screenCount === 0 })),
        !isCollapsed && (React.createElement(Box, { paddingRight: GUTTER },
            React.createElement(FlexWrap, { space: space[3] }, children)))));
}
